import { useContext } from "react";
import { useParams } from "react-router";

import { SheetScopeContext } from "@/contexts/SheetScopeContext";

export const useCurrentCompanyId = () => {
  // This is to allow CandidateSheet to be rendered in Aviary
  const sheetContext = useContext(SheetScopeContext);
  const { companyId: routeCompanyId } = useParams();

  const companyId = sheetContext?.companyId ?? routeCompanyId;
  if (!companyId) {
    throw new Error("Current company id not found");
  }

  return companyId;
};
